import { render, staticRenderFns } from "./ShippoDimensionsSizeUnit.vue?vue&type=template&id=3c13ba89&"
import script from "./ShippoDimensionsSizeUnit.vue?vue&type=script&lang=ts&"
export * from "./ShippoDimensionsSizeUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports